import { FavouriteAdminTranslation } from 'app/area/favourite-administration/constants';
import { FavouriteAdminListState } from 'app/area/favourite-administration/list/types-store';
import { ChangeOptionType } from 'app/area/favourite-administration/list/types';
import { FilterOption } from 'app/components/options-handler/types';
import { LoadOptions } from 'app/types-shared';
import { ValidationProps } from 'ui';

export enum ChangeOwnerField {
  fromOwners = 'fromOwners',
  toOwners = 'toOwners',
  applyOnDescendants = 'applyOnDescendants' 
}

export interface ChangeOwnerComponentProps {
  list: FavouriteAdminListState;
  options: {
    [key: string]: FilterOption;
  };
  translation: FavouriteAdminTranslation;
  validation: { [key: string]: ValidationProps };
  locale: string;
  onClose: () => void;
  save: (mode: ChangeOptionType, ownersToAdd: number[]) => void;
  updateByKey: <T>(key: string, value: T) => void;
  resetValidation: (key: string) => void;
  resetOwnersValidation: () => void;
  updateIsDirty: (value: boolean) => void;
  loadOptions: (id: string,
    componentEndpoint: string,
    loadOptionsParams: LoadOptions,
    optionsParams?: any) => void;
}

export interface ChangeOwnerFieldProps {
  list?: FavouriteAdminListState;
  translation?: FavouriteAdminTranslation;
  validation: { [key: string]: ValidationProps };
  locale: string;
  options: {
    [key: string]: FilterOption;
  };
  updateByKey: <T>(key: string, value: T) => void;
  resetValidation: (key: string) => void;
  updateIsDirty: (value: boolean) => void;
  loadOptions?: (id: string,
    componentEndpoint: string,
    loadOptionsParams: LoadOptions,
    optionsParams?: any) => void;
}
